<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="폼메일" tabActive="기본폼" bg="/images/test.jpg">
                <template #title>폼메일</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <form-input code="form-default" skin="form-default" />
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import FormInput from "@/components/client/form/form-input.vue";

export default {
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        FormInput,
    },
};
</script>
